<template>
  <v-card class="card-content-container">
    <v-card-title style="display: flex; justify-content: center">
      {{ mode }}
    </v-card-title>
    <v-form
      @submit.prevent="submitForm"
      ref="form"
      v-model="valid"
      class="mx-auto px-4"
      style="max-width: 1500px"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mx-1 mb-5"
      >
        {{ alertValidate }}</v-alert
      >
      <div class="mx-auto">
        <v-text-field
          v-if="inputsForm.length > 0"
          :name="inputsForm[0].name"
          v-model="inputsForm[0].data"
          :type="inputsForm[0].type"
          :label="inputsForm[0].label"
          :rules="inputsForm[0].rules"
          :multiple="multiple"
          outlined
          dense
          class="my-0"
        />

        <div>
          <v-select
            v-if="selects[0]"
            v-model="selects[0].data"
            :name="selects[0].name"
            :items="selects[0].items"
            :item-text="selects[0].itemsText"
            :item-value="selects[0].itemsValue"
            :label="selects[0].label"
            :rules="selects[0].rules"
            :multiple="multiple"
            outlined
            dense
            class="my-0"
          />
          <v-select
            v-model="selects[1].data"
            v-if="modo !== 'Editar' && selects[1]"
            :name="selects[1].name"
            :items="selects[1].items"
            :item-text="selects[1].itemsText"
            :item-value="selects[1].itemsValue"
            :label="selects[1].label"
            :rules="selects[1].rules"
            :multiple="multiple"
            outlined
            dense
          />
        </div>
        <v-text-field
          v-if="inputsForm.length > 0 && modo !== 'Editar'"
          :name="inputsForm[1].name"
          v-model="inputsForm[1].data"
          :type="inputsForm[1].type"
          :label="inputsForm[1].label"
          :rules="inputsForm[1].rules"
          :multiple="multiple"
          outlined
          dense
        />
        <DateWithCheck
          v-if="showDate && modo !== 'Editar'"
          :showCheck="showCheck"
          class="ma-0"
        />
        <div v-if="modo === 'Editar'" height="100" class="mx-n2">
          <TableWithSearch
            :items="editToClocks"
            :title="title"
            :headers="allHeaders"
            :openDialog="openDialogClock"
            @headersUpdated="updateHeadersClocks"
            @refreshItems="refreshItems"
            :showRefresh="true"
          />
        </div>

        <div class="d-flex justify-space-between py-4">
          <v-btn class="bt-exit" @click="cancel">{{
            $tc("editRegistrations.cancel")
          }}</v-btn>
          <v-btn type="submit" class="bt-acept">
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </div>
      </div>
    </v-form>
    <v-dialog v-model="openClock" :max-width="'600px'" persistent>
      <Form
        :key="modoClock"
        :items="computedItems"
        :itemsSelect="computedItemsSelect"
        @save="save"
        @cancel="reset"
        :maxWidth="'600px'"
        :show="true"
        :mode="modeClock"
        :showDate="true"
        :showCheck="true"
      />
    </v-dialog>
    <DeleteDialogClock
      :showDialog="openDeleteClock"
      :title="titleDeleteClock"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
      :maxWidth="'500px'"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-card>
</template>
<script>
import DeleteDialogClock from "@/components/Complement/DeleteDialog.vue";
import costCenters from "@/store/centrosDeCosto/costCenters";
import clocks from "@/store/centrosDeCosto/clocks";
import date from "@/store/common/date";
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import Form from "@/components/Complement/Form.vue";
import Vue from "vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import moment from "moment";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    DateWithCheck,
    Date,
    Form,
    TableWithSearch,
    DeleteDialogClock,
    Snackbar,
  },
  props: {
    items: {
      type: Array,
    },
    maxWidth: String,
    mode: String,
    itemsSelect: Array,
    show: {
      type: Boolean,
      default: false,
    },
    itemsSlider: Array,
    showDate: Boolean,
    showCheck: Boolean,
    multiple: Boolean,
    itemsCheckbox: Array,
  },
  data() {
    return {
      inputsForm: [],
      valid: true,
      error: false,
      alertValidate: "",
      selects: [],
      inputSlider: [],
      checkboxes: [],
      title: "Relojes",
      titleTable: this.$tc("costCenter.costCenters"),
      oldItems: {},
      titleDeleteClock: this.$tc("costCenter.toClockCostCenters"),

      inputs: [
        {
          name: "codRegExt",
          label: this.$tc("costCenter.ExtendedRegistrationCode"),
          data: "000",
          type: "text",
          rules: [
            (v) =>
              v.length <= 3 || this.$tc("costCenter.rulesDatacodRegExt3chart"),
          ],
        },
      ],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
    };
  },
  async created() {
    this.checkboxes = Vue.observable(this.itemsCheckbox);
    this.inputsForm = Vue.observable(this.items);
    this.selects = Vue.observable(this.itemsSelect);
    this.inputSlider = Vue.observable(this.itemsSlider);
    await clocks.dispatch("getClocks");
  },
  computed: {
    allHeaders() {
      return configTable.state?.colums?.clocks;
    },
    formItems() {
      if (this.modoClock === "Editar") {
        return this.inputs;
      } else {
        return [];
      }
    },
    formSelects() {
      if (this.modoClock === "Agregar") {
        return this.selectsData;
      } else {
        return [];
      }
    },
    modo() {
      if (this.mode === this.$tc("costCenter.addCostCenters")) {
        return this.$tc("commons.add");
      } else {
        return this.$tc("commons.edit");
      }
    },
    modoClock() {
      if (this.modeClock === this.$tc("costCenter.addClock")) {
        return this.$tc("commons.add");
      } else {
        return this.$tc("commons.edit");
      }
    },
    modeClock: {
      get() {
        return costCenters.state.modeClock;
      },
      set(newValue) {
        return newValue;
      },
    },

    relojes() {
      return this.itemsSelect[1].items;
    },
    openClock: {
      get() {
        return costCenters.state.openClock;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    editToClocks() {
      return costCenters.state.edit.relojes;
    },
    openDeleteClock: {
      get() {
        return costCenters.state.openDeleteClock;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    clocks() {
      return clocks.state.clocks;
    },
    selectsData() {
      return [
        {
          name: "relojId",
          label: this.$tc("costCenter.clocks"),
          data: [],
          items: this.clocks,
          itemsValue: "id",
          itemsText: "name",
          itemValueFunction: (item) => `${item.id}-${item.name}`,
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "mdi-pencil",
        },
      ];
    },
    computedItems() {
      return this.modoClock === "Editar" ? this.inputs : this.inputs;
    },
    computedItemsSelect() {
      return this.modoClock === "Agregar" ? this.selectsData : [];
    },
  },
  methods: {
    async refreshItems() {
      if (costCenters.state.edit.csCostoId) {
        await costCenters.dispatch(
          "getCostCentersId",
          costCenters.state.edit.csCostoId
        );
      }
    },
    updateHeadersClocks(headers) {
      const updatedColums = { ...configTable.state.colums, clocks: headers };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    openEditForm(item) {
      this.inputs[0].data = item.codRegisEx;
      this.selectsData[0].data = item.conceptoId;
      date.state.dateFrom = moment
        .utc(item.fecDesde, "DD-MM-YYYY")
        .format("YYYY-MM-DD");

      if (item.fecHasta !== "") {
        date.state.dateTo = moment
          .utc(item.fecHasta, "DD-MM-YYYY")
          .format("YYYY-MM-DD");
        date.state.checkTo = false;
      } else {
        date.state.checkTo = true;
      }

      costCenters.commit("setOpenClock", true);
    },
    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
      date.commit("setCheckTo", null);
    },

    reset() {
      this.resetDate();
      this.inputs.forEach((item) => {
        item.data = "";
      });
      costCenters.commit("setModeClock", "");
      costCenters.commit("setOpenClock", false);
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    save(items) {
      switch (this.typeForm) {
        case "add":
          this.addClock(items);
          break;
        case "edit":
          this.editClocks(items);
          break;
        default:
          break;
      }
    },
    addClock(items) {
      let payload = items;
      payload.csCostoId = costCenters.state.edit.csCostoId;
      payload.fecDesde = date.state.dateFrom;
      if (!date.state.checkTo) {
        payload.fecHasta = date.state.dateTo;
      }
      costCenters.commit("setNew", payload);
      costCenters
        .dispatch("addClock")
        .then(() => {
          costCenters.commit("setOpenClock", false);
          this.showAlert(this.$tc("costCenter.addClockSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(this.$tc("costCenter.addClockError"), "#ff8d58");
        });
      this.reset(false);
    },
    sendEdit(updatedItem) {
      costCenters.commit("setEditClock", updatedItem);

      costCenters
        .dispatch("editClock")
        .then(() => {
          costCenters.commit("setOpenClock", false);
          this.showAlert(this.$tc("costCenter.editClockSuccess"), "#82A1D0");
        })
        .catch((e) => {
          console.error("Error al aplicar los cambios:", e);
          this.showAlert(this.$tc("costCenter.editClockError"), "#ff8d58");
        });

      this.reset(false);
    },

    editClocks(items) {
      const targetItemId = this.itemId;
      const targetItem = costCenters.state.edit.relojes.find(
        (item) => item.relojId === targetItemId
      );

      items.fecDesde = date.state.dateFrom;
      items.fecHasta = date.state.dateTo;

      const changes = {};

      if (
        items.codRegExt !== undefined &&
        items.codRegExt !== targetItem.codRegisEx
      ) {
        changes.codRegisEx = items.codRegExt;
      }

      if (
        items.fecDesde !== undefined &&
        moment.utc(items.fecDesde, "YYYY-MM-DD").format("DD-MM-YYYY") !==
          this.oldItems.fecDesde
      ) {
        const formattedFecDesde = moment
          .utc(items.fecDesde, "YYYY-MM-DD")
          .format("DD-MM-YYYY");
        const oldFecDesde = this.oldItems.fecDesde;

        if (formattedFecDesde !== oldFecDesde) {
          changes.fecDesde = formattedFecDesde;
        }
      }

      if (
        items.fecHasta !== undefined &&
        moment.utc(items.fecHasta, "YYYY-MM-DD").format("DD-MM-YYYY") !==
          this.oldItems.fecHasta
      ) {
        const formattedFecHasta = moment
          .utc(items.fecHasta, "YYYY-MM-DD")
          .format("DD-MM-YYYY");
        const oldFecHasta = this.oldItems.fecHasta;

        if (formattedFecHasta !== oldFecHasta) {
          changes.fecHasta = formattedFecHasta;
        }
      }

      if (Object.keys(changes).length > 0) {
        const updatedItem = { ...targetItem, ...changes };
        updatedItem.csCostoId = costCenters.state.edit.csCostoId;
        updatedItem.fecDesde = moment
          .utc(updatedItem.fecDesde, "DD-MM-YYYY")
          .format("YYYY-MM-DD");
        updatedItem.fecHasta = moment
          .utc(updatedItem.fecHasta, "DD-MM-YYYY")
          .format("YYYY-MM-DD");
        updatedItem.oldItems = this.oldItems;

        this.sendEdit(updatedItem);
      } else {
        costCenters.commit("setOpenClock", false);
        this.showAlert(this.$tc("costCenter.editClockAlert"), "#f1c232");
      }
    },

    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();

      this.$emit("save", itemsComplete);
    },
    cancel() {
      this.$refs.form.resetValidation();

      this.$emit("cancel", false);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    handleChange(i) {
      console.log(i);
    },
    async openDialogClock(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          await costCenters.commit(
            "setModeClock",
            this.$tc("costCenter.addClock")
          );
          costCenters.commit("setOpenClock", true);
          break;
        case "edit":
          this.oldItems = item;
          this.itemId = item.relojId;
          await costCenters.commit(
            "setModeClock",
            this.$tc("costCenter.editClock")
          );
          await this.openEditForm(item);
          break;
        case "delete":
          costCenters.commit("setOpenDeleteClock", true);
          item.fecDesde = moment
            .utc(item.fecDesde, "DD-MM-YYYY")
            .format("YYYY-MM-DD");
          this.itemToDelete = item;
          this.itemToDelete.csCostoId = costCenters.state.edit.csCostoId;

          break;

        default:
          break;
      }
    },
    deleteItem() {
      costCenters.commit("setItemDelete", this.itemToDelete);
      costCenters
        .dispatch("deleteClock")
        .then(() => {
          costCenters.commit("setOpenDeleteClock", false);
          this.showAlert(this.$tc("costCenter.deleteClockSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e, "#ff8d58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      costCenters.commit("setOpenDeleteClock", false);
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1520px;
}

.slider-input {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.slider-container {
  border: 1px solid #959595;
  margin-bottom: 30px;
  height: 110px;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.card-content-container {
  max-width: 1500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
